const authRequest = async (url, options = {}) => {
  const user = JSON.parse(localStorage.getItem('User'));
  const token = user?.token;

  const headers = {
    'Content-Type': 'application/json',
    ...(user?.id_usuario && { 'X-User-ID': user.id_usuario }),
    ...options.headers,
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(url, {
    ...options,
    headers,
    credentials: 'include',
  });

  const data = await response.json();

  if (!data.status || !response.ok) {
    let message = 'An error occured!';

    if (data.mensagem === "Token de autorização não fornecido." 
      || data.mensagem === "Token inválido ou expirado.") {
      localStorage.removeItem('User');
      window.location.href = '/';
      return { error: true, message: 'Não autorizado' };
    }

    if (data?.mensagem || data?.message) {
      message = data?.mensagem || data?.message;
    }

    return { error: true, message, statusCode: data.code };
  }

  return {...data, message: data.mensagem};
};

export const getRequest = (url) => authRequest(url);

export const postRequest = (url, body) => authRequest(url, {
  method: 'POST',
  body: JSON.stringify(body),
});

export const patchRequest = (url, body) => authRequest(url, {
  method: 'PATCH',
  body: JSON.stringify(body),
});

export const deleteRequest = (url) => authRequest(url, { method: 'DELETE' });